module.exports = __webpack_public_path__ + "img/new_ticket.26181d04.svg";